import React from "react";

export default function FeatureSection() {
  return (
    <section className="px-4 py-16 max-w-7xl mx-auto">
      <div className="text-center mb-10">
        <button className="text-sm px-3 py-1 bg-gray-100 rounded-full mb-3">
          Features
        </button>
        <h2 className="text-4xl md:text-5xl font-bold mb-2">
          Out Top Features
        </h2>
        <p className="text-gray-500 max-w-xl mx-auto">
          Simplify project planning, streamline collaboration, and boost
          productivity all with Pixell task management solution
        </p>
      </div>

      <div className="grid grid-flow-col grid-rows-2 gap-4 my-10">
        <div className="row-span-2 ...">
          <div className="relative bg-black text-white rounded-xl p-4 ">
            <img
              src="/assests/images/LandingPage/work-section.jpg"
              alt="Feature Upgrade"
              className="w-full h-36 object-cover rounded-lg mb-4"
            />
            <h3 className="text-xl font-semibold">New feature upgrades</h3>
            <p className="text-sm">Added every month.</p>
          </div>
        </div>
        <div className="row-span-2 ...">
          <div className="bg-white rounded-xl p-4 shadow">
            <img
              src="/assests/images/LandingPage/work-section.jpg"
              alt="Dedicated KAM"
              className="w-full h-36 object-cover rounded-lg mb-4"
            />
            <h3 className="text-lg font-semibold">Dedicated KAM</h3>
            <p className="text-sm text-gray-500">KAM brief 2 lines max</p>
          </div>
        </div>
        <div className="col-span-2  ...">
          <div className="bg-white rounded-xl p-4 shadow flex flex-col items-center justify-center h-28">
            <h3 className="text-lg font-semibold mb-2">
              Manage your own timeline
            </h3>
            <div className="flex gap-2">
              <div className="w-6 h-6 bg-blue-500 rounded-full"></div>
              <div className="w-6 h-6 bg-gray-300 rounded-full"></div>
            </div>
          </div>
        </div>
        <div className="col-span-2 row-span-1 ...">
          {" "}
          <div className="bg-black text-white rounded-xl p-4 flex items-center justify-center h-28">
            <h3 className="text-lg font-semibold">And much more...</h3>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="row-span-3 col-span ...">
          <div className="relative bg-black text-white rounded-xl p-4 ">
            <img
              src="/assests/images/LandingPage/work-section.jpg"
              alt="Feature Upgrade"
              className="w-full h-36 object-cover rounded-lg mb-4"
            />
            <h3 className="text-xl font-semibold">New feature upgrades</h3>
            <p className="text-sm">Added every month.</p>
          </div>
        </div>
        <div className="md:col-span-2 bg-white rounded-xl p-4 shadow">
          <h3 className="text-lg font-semibold mb-2">
            Everything on your fingertips
          </h3>
          <p className="text-sm text-gray-500 mb-4">Simply, with one click.</p>
          <div className="flex gap-4 overflow-x-auto">
            <img
              src="/assests/images/LandingPage/work-section.jpg"
              alt="Dashboard Screenshot"
              className="rounded-lg h-36"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
